const formTranslations = {
    title: 'Start Your Transformation',
    descriptionStart: 'Start your body transformation journey now with',
    informa: 'informa',
    descriptionEnd: ', fill up the form to get your customized program now.',
    actionButton:'Next',
    backButton:'Back',
    submitButton:'Submit'
}

export default formTranslations;